import React from 'react';
import { Col, Row } from 'reactstrap';
import { FormGroup, Label, Input } from 'reactstrap';

export default function TermoCienciaGerador({ termoHtml, aceitou, onChangeAceitou, errors }) {
    return (
        <div>
            <Row className="mb-3">
                <Col md="12">
                    <h6 className="fw-bold">Termo de ciência – declaração de veracidade</h6>
                    <div
                        className="border rounded p-3 bg-light"
                        style={{
                            maxHeight: '320px',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            fontSize: '0.9rem',
                            lineHeight: '1.6'
                        }}
                    >
                        {termoHtml}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md="12">
                    <FormGroup check>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="chk_aceitou_termo"
                                checked={aceitou}
                                onChange={(e) => onChangeAceitou(e.target.checked)}
                            />{' '}
                            Declaro que li e que as informações prestadas são verdadeiras.
                        </Label>
                    </FormGroup>
                    {errors?.aceitouTermo && (
                        <span className="form-control-label text-danger">
                            {errors.aceitouTermo}
                        </span>
                    )}
                </Col>
            </Row>
        </div>
    );
}
